// =======================
// src/paginas/secretaria/sre/EditarSre.js
// =======================

import React from "react";

import { useParams } from "react-router-dom";

import FormularioSre from "./FormularioSre";

export default function EditarSre() {
  const { id } = useParams();

  return <FormularioSre id={id} />;
}
